<template>
  <div style="width: 100%;">
    <v-container>
      <v-row>
        <v-col class='d-flex flex-row align-center'>
          <v-btn text class="mx-2" @click="()=>{this.$router.go(-1)}">
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          <span class="d-flex flex-column">
            <h1>{{this.singular}}: {{this.data.firstName}} {{this.data.lastName}}</h1>
            <span v-if="this.data.metadata&&this.data.metadata.badLogins">Bad Logins: {{this.data.metadata.badLogins}}</span>
          </span>
          <v-progress-circular
            indeterminate
            color="green"
            v-if="loader"
            style="margin-left: 10px;"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn @click="isEditable = !isEditable">
            <span v-if="this.isEditable">Cancel</span>
            <span v-else>Edit</span>
          </v-btn>
        </v-col>
        <v-col>
          <v-btn :disabled="!this.data.isLoggedIn" @click="this.forceLogout">Force Logout</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
              label="First Name"
              :disabled="!this.isEditable"
              outlined
              v-model="data.firstName"
          />
          <v-text-field
              label="Last Name"
              :disabled="!this.isEditable"
              outlined
              v-model="data.lastName"
          />
          <v-text-field
              label="Address"
              :disabled="!this.isEditable"
              outlined
              v-model="data.address"
          />
          <v-menu
              :close-on-content-click="false"
              :disabled="!this.isEditable"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="data.dateOfBirth"
                  label="Date of Birth"
                  prepend-icon="mdi-calendar"
                  readonly
                  outlined
                  v-bind="attrs"
                  v-on="on"
              />
            </template>
            <v-date-picker
                v-model="data.dateOfBirth"
            />
          </v-menu>
          <v-select
              item-text="name"
              item-value="id"
              :items="userTypes"
              label="User Type"
              outlined
              :disabled="!this.isEditable"
              v-model="data.userTypeId"
          />
        </v-col>
        <v-col>
          <v-text-field
              label="Phone"
              :disabled="!this.isEditable"
              outlined
              v-model="data.phone"
          />
          <v-text-field
              label="Email"
              :disabled="!this.isEditable"
              outlined
              v-model="data.email"
          />
          <v-text-field
              label="Username"
              :disabled="true"
              outlined
              v-model="data.username"
          />
          <v-btn color='info' @click="openResetPassDialog">Reset Password</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn v-if="isEditable" @click="update">Save</v-btn>
          <v-btn v-if="isEditable" style="margin-left: 10px;" class="error" @click="deleteData">Delete</v-btn>
        </v-col>
        <v-col>
          <span v-if="this.isEditable">
            <v-chip
                v-for="device in registeredDevices" :key="device.id"
                class="ma-2"
            >
              {{device.name}} - {{device.id}}
            </v-chip>
          </span>
          <v-textarea
              :disabled="!this.isEditable"
              label="Printers"
              outlined
              v-model="data.metadata.printers"
          />
          <v-textarea
              label="Secure ID Token"
              :disabled="!this.isEditable"
              outlined
              v-model="data.metadata.sIdToken"
          />
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
      v-model="resetPassDialog.open"
      max-width="490"
    >
      <v-card>
        <v-card-title class="text-h5">
          Reset This Passsword?
        </v-card-title>
        <v-card-text>
          <v-text-field
              label="Admin Password"
              outlined
              v-model="resetPassDialog.adminPass"
              type="password"
          />
          <v-text-field
              :label="'New Password for '+ this.data.firstName"
              outlined
              v-model="resetPassDialog.newPass"
          />
          <v-btn @click="resetSecureIdToken()" color="warning">Reset Secure ID Token</v-btn>
          <v-btn @click="unsuspend()" color="warning">Unsuspend Account</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="closeResetPassDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            color="error"
            @click="resetPass()"
          >
            Reset
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </div>
</template>

<script>
  import { mapGetters } from "vuex"
  import axios from 'axios';
  export default {
    data () {
      return {
        deleteDialog: false,
        deleteConfirmed: true,
        loader: true,
        snackObj: {
          color: '',
          text: ''
        },
        max25chars: v => v.length <= 25 || 'Input too long!',
        editMode: false,
        data: {metadata: {sIdToken: ''}},
        singular: "User",
        singularLower: "user",
        plural: "Users",
        pluralLower: "users",
        isEditable: false,
        userTypes: [],
        resetPassDialog: {
          open: false,
          adminPass: '',
          newPass: '',
        },
        registeredDevices: [],
      }
    },
    async mounted(){
        try {
          let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)
          this.data = res.data
          if(!this.data.metadata){
            this.data.metadata = {sIdToken: ''}
          }
          if(this.data.dateOfBirth){
            this.data.dateOfBirth = new Date(this.data.dateOfBirth).toISOString().substring(0, 10);
          }
          if(!this.data.metadata.printers){
            this.data.metadata.printers = '{"allowed": "[]", "default": "[]"}'
          }else{
            this.data.metadata.printers = JSON.stringify(this.data.metadata.printers)
          }

          let uts = await axios.get(`${this.getEndpoint}/api/usertypes`);
          this.userTypes = uts.data
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
          this.loader = false;
        }
    },
    computed: {
      ...mapGetters(['getUser', 'getId', 'getEndpoint'])
    },
    methods: {
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.color = color;

        this.$refs.snackbar.openDialog();
      },
      async update(){
        try {
          this.loader = true;
          this.data.metadata.printers = JSON.parse(this.data.metadata.printers)
          let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`, this.data)
          console.log(res);
          if(res.data.success){
            this.snack(`${this.singular} info Updated 🎉`, "success")
            this.isEditable = false;
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
          this.loader = false;
        }
      },
      async unsuspend(){
        try {
          this.loader = true;          
          let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/unsuspend/${this.$route.params.id}`, this.data)
          console.log(res);
          if(res.data.success){
            this.snack(`Account Unsuspended 🎉`, "success");
            this.isEditable = false;
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
          this.loader = false;
        }
      },
      async deleteData(){
        try {
          this.loader = true
          let res = await axios.delete(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)
          if(res.status == 200){
            this.snack(this.singular+" Deleted 🎉", "success");
            setTimeout(()=>{
              this.$router.push({ path: `/${this.pluralLower}`})
            }, 1000)
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      },
      openResetPassDialog(){
        this.resetPassDialog.open = true;
      },
      closeResetPassDialog(){
        this.resetPassDialog.open = false;
        this.openResetPassDialog.adminPass = ''
        this.openResetPassDialog.newPass = ''
      },
      async resetPass(){
        try {
          let data = this.resetPassDialog
          data.adminId = this.getId
          console.log(data)
          let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/editPassword/${this.$route.params.id}`, data)
          if(!res) throw "Error. Perhaps it is your password."
          if(res.data.success){
            this.snack("Password Updated", "success")
            this.closeResetPassDialog()
          }else throw "Password not updated"
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      },
      //superadmin only
      async forceLogout(){
        try {
          let res = await axios.post(`${this.getEndpoint}/api/${this.pluralLower}/forceLogout/${this.$route.params.id}`)
          if(res.status == 200){
            this.snack("User Logged Out 🎉", "success");
            this.data.isLoggedIn = false
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      },
      async resetSecureIdToken(){
        try {
          let res = await axios.post(`${this.getEndpoint}/api/${this.pluralLower}/resetSecureIdToken/`, {uId: this.$route.params.id})
          if(res.status == 200){
            this.snack("SID Created", "success")
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      }
    }
  }
</script>
